// Расшиерния файлов взял из доступных в модалке создания
export const checkFileIsImage = (extension: string) => /(jpeg|jpg|png)$/.test(extension.toLowerCase());
